import React from 'react';
import {connect} from "react-redux";
import $ from "jquery";
import {injectIntl} from "react-intl";

import {
  setShowUnlockCalculations,
  setUnlockCalculationsStep,
  showUnlockCalculationsCartItems, showUnlockCalculationsTotalItems
} from "../../actions/unlockCalculationsFunctions";
import LoadingDots from "../ui/loadingDots";
import {ProductsIconAnimated, TimingIconAnimated} from "../common/icons";
import UserLoginButton from "../ui/userLoginButton";
import {toggleUserPopup} from "../../actions/actionFunctions";
import {
  getUnlockCalculationsCartItems
} from "../look/popups/leadCapturePopup/unlockCalculations/unlockCalculationSteps";


class UnlockCalculationsSteps extends React.Component {

  overlayElement = null;
  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    window.renderUnlockCalcTimes = window.renderUnlockCalcTimes > -1 ? window.renderUnlockCalcTimes + 1 : 0;
    setTimeout(() => {
      if (this.overlayElement) {
        $(this.overlayElement).fadeIn(300, () => {
          this.runAnimations();
        })
      }
    }, 500)
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.showUnlockCalculationsCartItems([]);
    this.props.showUnlockCalculationsTotalItems([]);
    this.props.setUnlockCalculationsStep(0);
  }

  runAnimations = async () => {
    this.props.setUnlockCalculationsStep(1);
    this.showCartItems();
    await new Promise(resolve => setTimeout(resolve, 2500));
    this.props.setUnlockCalculationsStep(2);
    await new Promise(resolve => setTimeout(resolve, 2500));
    this.props.setUnlockCalculationsStep(3);
    this.showTotalItems();
    await new Promise(resolve => setTimeout(resolve, 2500));
    this.props.setUnlockCalculationsStep(4);
    await new Promise(resolve => setTimeout(resolve, 300));
    this.exitRunAnimations();
  };

  showCartItems = () => {
    const {cartItems, wizardList, wizardIsActive, allWizardsValues, lookPageOpened, quotes} = this.props;
    const cartItemsToInclude = getUnlockCalculationsCartItems(cartItems, wizardList, wizardIsActive,
        allWizardsValues, lookPageOpened, quotes);
    for (const [index, element] of cartItemsToInclude.entries()) {
      // const waitTime = this.props.cartItems.length < 7 ? 500*(index + 1) : 300*(index + 1);
      const currentRenderTime = window.renderUnlockCalcTimes;
      const waitTime = 750*(index + 1);
      const renderIndex = "timeout" + window.renderUnlockCalcTimes + index;
      this[renderIndex] = setTimeout(() => {
        if (this._isMounted && currentRenderTime === window.renderUnlockCalcTimes) {
          this.props.showUnlockCalculationsCartItems([...this.props.showCartItems, element.id]);
        } else {
          clearTimeout(this[renderIndex])
        }
      }, waitTime)
    }
  };

  showTotalItems = () => {
    setTimeout(() => {
      this.props.showUnlockCalculationsTotalItems(["tax"]);
    }, 500);
    setTimeout(() => {
      this.props.showUnlockCalculationsTotalItems(["tax", "total"]);
    }, 1000);
  };

  exitRunAnimations = () => {
    if (this.overlayElement) {
      $(this.overlayElement).fadeOut(300, () => {
        const currentRenderTime = window.renderUnlockCalcTimes;
        setTimeout(() => {
          if (this._isMounted && currentRenderTime === window.renderUnlockCalcTimes) {
            UserLoginButton.handleLoginClick({...this.props})
          }
        }, 5000);
      })
    }
  };

  getStep = (stepStart, icon, title, text) => {
    const currentStep = this.props.unlockCalculationsStep;
    return (currentStep === stepStart || currentStep === stepStart + 1) ? (
      <div className={"unc-step"
      + (currentStep === stepStart ? " animated animate__fadeInUp" : "")
      + (currentStep === stepStart + 1 ? " animated animate__fadeOutUp" : "")
      }>
        <div className="unc-step-content">
          <div className={"unc-step-content__icon unc-step-content__icon--" + icon}>
            {stepStart === 1 ? <ProductsIconAnimated/> : null}
            {stepStart === 2 ? <TimingIconAnimated/> : null}
          </div>
          <div className="unc-step-content__text">
            <p className="unc-title">{title}</p>
            <p className="unc-calculating">
              <span className="unc-calculating__text">{text}</span>
              <LoadingDots/>
            </p>
          </div>
        </div>
      </div>
    ) : null
  }

  render() {
    const currentStep = this.props.unlockCalculationsStep;
    const {intl} = this.props;
    return (
      <div className={"overlay overlay--semi-dark" + (!currentStep ? " overlay--hidden" : "")}
           ref={(node) => this.overlayElement = node}>
        {this.getStep(
          1,
          "products",
          intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.step1Title"}),
          intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.step1Text"})
        )}
        {this.getStep(
          2,
          "installation",
          intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.step2Title"}),
          intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.step2Text"})
        )}
        {this.getStep(
          3,
          "total",
          intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.step3Title"}),
          intl.formatMessage({id: "shoppingCart.unlockCalculationsTutorial.step3Text"})
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const {wizardList, wizardIsActive, allWizardsValues} = store.wizardState;
  const {lookPageOpened} = store.lookState;
  const {quotes} = store.quotesState;

  return {
    showUnlockCalculations: store.unlockCalculationsState.showUnlockCalculations,
    cartItems: store.cartState.cartItems,
    unlockCalculationsStep: store.unlockCalculationsState.unlockCalculationsStep,
    showCartItems: store.unlockCalculationsState.showCartItems,
    showTotalItems: store.unlockCalculationsState.showTotalItems,
    wizardList, wizardIsActive, allWizardsValues,
    lookPageOpened,
    quotes,
  };
};

const mapDispatchToProps = {
  setShowUnlockCalculations,
  setUnlockCalculationsStep,
  showUnlockCalculationsCartItems,
  showUnlockCalculationsTotalItems,
  toggleUserPopup
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UnlockCalculationsSteps)
)
